import { render } from "./Selector.vue?vue&type=template&id=470b9004&scoped=true&ts=true"
import script from "./Selector.vue?vue&type=script&lang=ts"
export * from "./Selector.vue?vue&type=script&lang=ts"

import "./Selector.vue?vue&type=style&index=0&id=470b9004&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470b9004"]])

export default __exports__